<template>
    <div>

        <!--导航栏 start-->
        <van-nav-bar
                title="添加商户"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏 end-->
        <!--内容部分 start-->
              <van-form @submit="onSubmit" style="margin-top: 1.5rem">
            <van-field
                    v-model="username"
                    name="商户编号"
                    left-icon="contact"
                    placeholder="请输入商户编号"
                    :rules="[{ required: true, message: '商户编号不能为空' }]"
            />
            <van-field
                    v-model="password"
                    type="password"
                    name="密码"
                    left-icon="goods-collect-o"
                    placeholder="请输入密码"
                    :rules="[{ required: true, message: '，密码不能为空' }]"
            />
        </van-form>
          <div style="margin: 16px;">
                <van-button @click="onSubmit" round block type="info" native-type="submit">
                    确定
                </van-button>
            </div>
        <!--内容部分 end-->


    </div>
</template>

<script>
  // import VueCookie from 'vue-cookies'
    import {Notify, Toast} from 'vant';
    export default {
        name: "MerchantLogin", //商户添加
        data() {
            return {
                username: '',
                password: '',

            };
        },
        // 组件内路由--进入组件时
        beforeRouteEnter(to, from, next) {
            window.document.body.style.backgroundColor = '#f5f5f5';
            next();
        },
        // 组件内路由--离开组件时
        beforeRouteLeave(to, from, next) {
            window.document.body.style.backgroundColor = '';
            next();
        },
        methods: {
            // 左侧返回
            onClickLeft() {
                this.$router.push("/MerchantImpower");
                // window.history.go(-1)
            },
            // 提交
            onSubmit() {
                 // window.sessionStorage.setItem("tag",this.ta)
                //  var that = this;
                 var toast = Toast.loading({
                    duration: 0,
                    message: '添加中',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                // console.log('submit', values);
                this.$http.get('/wechat/user/merchant_login', {
                    params: {
                        username: this.username,
                        password: this.password,
                        openid: window.localStorage.getItem("openid")
                    }
                }).then(response => {
                     toast.clear();
                    console.log(response.data);
                    if (response && response.data.code== 200) {

                         this.$router.push("/MerchantImpower");

                        // VueCookie.set('salesmanInfo', response.data.data, 360000);
                        // window.location.href = that.redirect;

                    }else{
                       Notify({type: 'danger', message: response.data.msg});
                    }
                })



            },
        },
    }
</script>

<style >
.van-icon-goods-collect-o::before{
    position: relative;
    top: 0.1rem;
}
.van-icon-contact::before{
    position: relative;
    top: 0.1rem;
}
</style>
